import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import SwiperCore, {
  Autoplay,
  Controller,
  Navigation,
  Pagination,
} from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { getCookie, setCookie } from "../../common/auth";
import { getNextDate } from "../../common/util/getDate";
import { useBannerStore } from "@store/useBannerStore";

SwiperCore.use([Navigation, Autoplay, Pagination, Controller]);

const Wrapper = styled.div`
  position: ${(props) =>
    (props.$scroll === "bannerHidden" && "fixed") || "absolute"};
  top: ${(props) =>
    (props.$scroll === "scrollCheck" && "10px") ||
    (props.$scroll === "bannerHidden" && "90px") || // fixed 상태에서는 상단에 적절한 여백
    "365px"};
  left: calc(((100vw) / 2 - 570px) - 170px);
  max-width: 150px;
  height: 350%;
  z-index: 999;
  background-color: transparent;
  display: block;

  @media screen and (max-width: 1600px) {
    left: 5px;
  }
  @media screen and (max-width: 1200px) {
    display: none;
  }
  @media screen and (max-width: 991px) {
    display: none;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const StickyWrapper = styled.div`
  position: sticky;
  top: 90px;
  height: auto;
  display: flex;
  align-items: center;
  & img {
    width: 150px !important;
  }
`;

const SwiperArrows = styled.div`
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
  width: 150px;
  & span {
    border-radius: 20%;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px;
    background-color: #fff;
    margin-right: 5px;
    cursor: pointer;
    :last-of-type {
      margin-right: 0px;
    }
    z-index: 999;
    :hover {
      color: #3bb77e;
    }
  }
`;

const MobileBannerBg = styled.div`
  display: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  @media screen and (max-width: 768px) {
    display: flex;
  }
`;

const MobileBotBanner = styled.div`
  display: none;
  width: 100%;
  position: fixed;
  bottom: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #fff;
  padding: 10px 10px 5px;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: flex;
    .swiper-pagination-bullet {
      width: 10px !important;
      height: 10px !important;
    }
  }
`;

const BotImgWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
  width: 100%;
`;

const BotBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  word-break: keep-all;
  & span {
    width: 50%;
    display: flex;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    :hover {
      background-color: #ececec;
      color: #3bb77e;
    }
    :first-of-type {
      border-right: 1px solid #58585f;
    }
  }
`;

const SideBanner = () => {
  const { bannerList, mainSide, mobileBtm } = useBannerStore((s) => s);

  const hasMainSide = Array.isArray(mainSide) && mainSide.length > 0;
  const hasMobileBtm = Array.isArray(mobileBtm) && mobileBtm.length > 0;

  const swiperRef = useRef();
  const mobileSwiperRef = useRef();
  const [openBanner, setOpenBanner] = useState(true);
  const [sideSwiper, setSideSwiper] = useState({});
  const [scroll, setScroll] = useState("");

  const onClickClose = () => {
    setOpenBanner(false);
  };

  const onClickTodayClose = () => {
    const date = getNextDate();
    setCookie(`IgB`, date, {
      expires: date,
    });
    onClickClose();
  };

  const swiperOption = {
    navigation: { prevEl: ".custom_prev", nextEl: ".custom_next" },
    autoplay: { delay: 3000, disableOnInteraction: false },
    loop: mainSide?.length > 1 ? true : false,
  };

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY >= 100 && window.scrollY < 365;
      const bannderHidden = window.scrollY >= 365;

      if (scrollCheck) {
        return setScroll("scrollCheck");
      }
      if (bannderHidden) {
        return setScroll("bannerHidden");
      }
      setScroll("");
    });
  }, []);

  useEffect(() => {
    if (sideSwiper && sideSwiper.autoplay && mainSide?.length > 1) {
      sideSwiper.autoplay.start();
      sideSwiper.autoplay.run();
      sideSwiper.update();
    }
    if (
      !getCookie(`IgB`) &&
      bannerList &&
      mobileBtm?.length > 0 &&
      openBanner &&
      mobileSwiperRef.autoplay
    ) {
      mobileSwiperRef.autoplay.start();
      mobileSwiperRef.autoplay.run();
      mobileSwiperRef.update();
    }
  });

  return (
    <>
      <Wrapper $scroll={scroll}>
        {hasMainSide && bannerList && (
          <StickyWrapper>
            <Swiper
              ref={swiperRef}
              className="sideBanner"
              {...swiperOption}
              observeParents={true}
              observer={true}
              onSwiper={setSideSwiper}
              updateOnWindowResize={true}
            >
              {mainSide.map((el, i) => (
                <SwiperSlide key={i}>
                  {el?.P_FileUrl ? (
                    <a
                      href={el.link_url || "#"}
                      target={el.new_win === "Y" ? "_blank" : "_self"}
                    >
                      <img
                        src={el.P_FileUrl}
                        alt={el.img_alt || "광고 이미지"}
                      />
                    </a>
                  ) : null}
                </SwiperSlide>
              ))}
            </Swiper>
            {bannerList && mainSide?.length > 0 && (
              <SwiperArrows className={mainSide?.length == 1 && "d-none"}>
                <span className="custom_prev">
                  <i className="fi-rs-angle-small-left" />
                </span>
                <span className="custom_next">
                  <i className="fi-rs-angle-small-right" />
                </span>
              </SwiperArrows>
            )}
          </StickyWrapper>
        )}
      </Wrapper>
      {!getCookie(`IgB`) && hasMobileBtm && openBanner && (
        <MobileBannerBg>
          <MobileBotBanner>
            <BotImgWrapper>
              <Swiper
                className="mobileBotBanner "
                autoplay={true}
                pagination={true}
              >
                {mobileBtm.map((el, i) =>
                  el?.M_FileUrl ? (
                    <SwiperSlide key={i}>
                      <a
                        href={el.link_url || "#"}
                        target={el.new_win === "Y" ? "_blank" : "_self"}
                        rel={
                          el.new_win === "Y" ? "noopener noreferrer" : undefined
                        }
                      >
                        <img
                          src={el.M_FileUrl}
                          alt={el.img_alt || "모바일 배너"}
                        />
                      </a>
                    </SwiperSlide>
                  ) : null
                )}
              </Swiper>
            </BotImgWrapper>
            <BotBtnWrapper>
              <span onClick={onClickTodayClose}>오늘 그만보기</span>
              <span onClick={onClickClose}>닫기</span>
            </BotBtnWrapper>
          </MobileBotBanner>
        </MobileBannerBg>
      )}
    </>
  );
};
export default SideBanner;
